import React from 'react';
import StyledLinksColumn from '../../ui-library/styled/StyledLinksColumn';
import StyledAHREF from './StyledAHREF';
import StyledLink from './StyledLink';
import {
  STR_GALLERY,
  STR_STORE,
  URL_COLOR_GENIE_PUBLIC,
  URL_FAQ,
  URL_GALLERY,
  URL_GENIE_PUBLIC,
  URL_STORE,
} from '../../utils/constants';
import { trackFooterNavigateClick } from '../tracking/discovery.tracking';
import {
  STR_FAQ,
  STR_BLOG,
  STR_GENIE,
  STR_SHOP,
  STR_COLOR_GENIE,
} from '../tracking/discovery.tracking.constants';

const trackFAQClick = () => {
  trackFooterNavigateClick(STR_FAQ);
};
const trackShopClick = () => {
  trackFooterNavigateClick(STR_SHOP);
};
const trackGalleryClick = () => {
  trackFooterNavigateClick(STR_GALLERY);
};
const trackColorGenieClick = () => {
  trackFooterNavigateClick(STR_COLOR_GENIE);
};
const trackGenieClick = () => {
  trackFooterNavigateClick(STR_GENIE);
};
const trackBlogClick = () => {
  trackFooterNavigateClick(STR_BLOG);
};

const SiteLinks = () => {
  return (
    <StyledLinksColumn>
      <StyledLink to={URL_FAQ} onClick={trackFAQClick}>
        FAQ
      </StyledLink>
      <StyledLink to={URL_STORE} onClick={trackShopClick}>
        {STR_STORE}
      </StyledLink>
      <StyledLink to={URL_GALLERY} onClick={trackGalleryClick}>
        {STR_GALLERY}
      </StyledLink>
      <StyledLink to={URL_COLOR_GENIE_PUBLIC} onClick={trackColorGenieClick}>
        Color Genie
      </StyledLink>
      <StyledLink to={URL_GENIE_PUBLIC} onClick={trackGenieClick}>
        Genie
      </StyledLink>
      <StyledAHREF href='https://blog.askokey.com' onClick={trackBlogClick}>
        Blog
      </StyledAHREF>
    </StyledLinksColumn>
  );
};

export default SiteLinks;
